const AppConstants = {
  // api: "https://kapila-wms-ehsb3.ondigitalocean.app",
  api: "https://api.kapila.industrialdata.in",
  // api: "http://localhost:5000",
  // api: 'https://api.digimach.io'
};

export default AppConstants